<script>
  import { HIGHLIGHT_URL } from "../util/constants";
  import ExternalLink from "./ExternalLink.svelte";
  import Header from "./Header.svelte";
  import Paragraph from "./Paragraph.svelte";
  import TextPage from "./TextPage.svelte";
</script>

<TextPage>
  <Header>Terms & Conditions</Header>
  <Paragraph>
    Tordoff Films Ltd retains exclusive ownership of all film rights related to
    the film titled <em>Generative</em>. Any funds raised through art sales or
    crowdfund donations do not grant buyers or donors any legal rights, claims,
    or entitlements to the <em>Generative</em> film itself or to any future
    revenue, intellectual property, or creative decisions related to it.
    Contributions made toward the project support its creation but do not
    constitute an investment, partnership, or ownership interest in
    <em>Generative</em> film or in Tordoff Films Ltd.
  </Paragraph>
  <Paragraph>
    This is a donation-based crowdfund not subject to FCA regulation in the UK,
    and purchases are final and non-refundable. The artist has effectively
    chosen to donate his artwork to an independent film production company. The
    funds will at no point be under the artist's control, and Tordoff Films Ltd
    will be receiving and managing the proceeds from this sale, after deducting
    expenses related to crowdfund development and other processing fees.</Paragraph
  >
  <Paragraph
    >Payments and crypto transactions for the crowdfund are being operated by <ExternalLink
      href={HIGHLIGHT_URL}>Highlight</ExternalLink
    >, a Ethereum NFT auction platform, and the artist has waived all proceeds
    in order to support the film. The artist, filmmakers and crowdfund platform
    makes no guarantees, and bears no responsibility for loss of user funds. In
    the case a film is not or cannot be made for whatever reason, contributors
    will not be refunded their donations. Users are expected to interact with
    and use cryptocurrencies at their own risk.
  </Paragraph>
  <Paragraph
    >Direct donations to Tordoff Films Ltd through Endaoment and/or The Film
    Collaborative will not count toward the 32 Bit Edition rankings and will not
    mint any new NFTs.
  </Paragraph>
  <Paragraph>
    Although the artworks are being minted on the immutable Ethereum ledger, the
    contracts are upgradeable and mutable to allow the artist to respond to
    critical bugs and media preservation concerns. As the price of Ether may
    fluctuate, the minimum payment price might be adjusted throughout the course
    of the NFT sale. The artist reserves the right to close the auction early,
    or change any of the terms if needed to support the crowdfund.
  </Paragraph>
</TextPage>

<style>
</style>
